module.exports = __webpack_public_path__ + "img/szgxq3.20049468.jpg";